// Display only named business fields; responses are never rendered as raw objects.
const identityColumns = [
  { title: "ID", key: "id", dataIndex: "id", width: 100, fixed: "left" },
  { title: "用户ID", key: "userId", dataIndex: "userId", width: 110 },
  { title: "用户注册时间", key: "userCreateTime", dataIndex: "userCreateTime", width: 175 },
  { title: "记录创建时间", key: "createTime", dataIndex: "createTime", width: 175 },
  { title: "商品", key: "goodName", dataIndex: "goodName", width: 200 },
];
const commonDetails = [
  { key: "userId", label: "用户ID" },
  { key: "userCreateTime", label: "用户注册时间" },
  { key: "channel", label: "用户渠道" },
  { key: "appId", label: "应用ID" },
  { key: "appName", label: "应用名称" },
  { key: "goodId", label: "商品ID" },
  { key: "goodName", label: "商品名称" },
  { key: "merchantId", label: "商户ID" },
  { key: "merchantName", label: "商户名称" },
  { key: "outTradeNo", label: "商户订单号" },
  { key: "transactionId", label: "交易流水号" },
  { key: "originalTransactionId", label: "原始交易ID" },
  { key: "tradeType", label: "交易类型", tradeType: true },
  { key: "paidCount", label: "购买次数" },
  { key: "asset", label: "资产ID" },
  { key: "createDate", label: "记录创建日期" },
  { key: "createTime", label: "记录创建时间" },
];

export const payOrderSummaryFields = [
  { key: "id", label: "下单记录ID" },
  { key: "title", label: "订单标题" },
  { key: "amount", label: "订单金额", amount: true },
  { key: "paymentChannel", source: "tradeType", label: "支付方式", providerTradeType: true },
  { key: "prepayCode", label: "预支付结果" },
  { key: "payCode", label: "支付结果码" },
  { key: "payResult", label: "扣款失败原因" },
  ...commonDetails,
];

export const paymentSummaryFields = [
  { key: "id", label: "支付记录ID" },
  { key: "wechatOrderId", label: "关联下单记录ID" },
  { key: "payType", label: "支付方式", paymentType: true },
  { key: "resultCode", label: "支付结果码" },
  { key: "cashFee", label: "实付金额", amount: true },
  { key: "totalFee", label: "订单金额", amount: true },
  { key: "outTradeNo", label: "商户订单号" },
  { key: "transactionId", label: "交易流水号" },
  { key: "originalTransactionId", label: "原始交易ID" },
  { key: "tradeType", label: "交易类型", tradeType: true },
  { key: "paidCount", label: "支付次数" },
  { key: "createTime", label: "记录创建时间" },
];

export const agreementSummaryFields = [
  { key: "provider", label: "签约渠道", provider: true },
  { key: "id", label: "签约记录ID" },
  { key: "userId", label: "用户ID" },
  { key: "goodId", label: "商品ID" },
  { key: "merchantId", label: "商户ID" },
  { key: "status", label: "签约状态" },
  { key: "isAgreement", label: "当前已签约", boolean: true },
  { key: "firstDeductionAmount", label: "首次扣款金额", amount: true },
  { key: "nextDeductionAmount", label: "下次扣款金额", amount: true },
  { key: "firstDeductionDate", label: "首次扣款时间" },
  { key: "nextDeductionDate", label: "下次扣款时间" },
  { key: "paidCount", label: "成功扣款次数" },
  { key: "createTime", label: "记录创建时间" },
  { key: "cancelTime", label: "解约时间" },
];

export const orderRecordTypes = {
  "pay-orders": {
    title: "下单记录",
    listPath: "/order/pay-order/list",
    detailPath: "/order/pay-order/detail",
    note: "包含未支付订单，支付成功以支付结果码 SUCCESS 为准。日期留空查询全部，按 ID 倒序。金额由分折算，保留两位小数并标明币种。",
    columns: [
      ...identityColumns,
      { title: "支付方式", key: "tradeType", dataIndex: "tradeType", width: 120, providerTradeType: true },
      { title: "订单金额", key: "amount", dataIndex: "amount", width: 160, amount: true, align: "right" },
      { title: "支付状态", key: "isPaid", dataIndex: "isPaid", width: 110 },
      { title: "支付结果码", key: "payCode", dataIndex: "payCode", width: 140 },
      { title: "扣款失败原因", key: "payResult", dataIndex: "payResult", width: 260, ellipsis: true },
      { title: "购买次数", key: "paidCount", dataIndex: "paidCount", width: 100, align: "right" },
      { title: "商户订单号", key: "outTradeNo", dataIndex: "outTradeNo", width: 240 },
    ],
    detailFields: [
      { key: "title", label: "订单标题" },
      { key: "prepayCode", label: "预支付结果" },
      { key: "payResult", label: "扣款失败原因" },
      ...commonDetails,
      { key: "renewStatus", label: "续订状态" },
      { key: "cancelStatus", label: "取消状态" },
      { key: "cancelTime", label: "取消时间" },
      { key: "cancelSignTime", label: "取消签约时间" },
    ],
  },
  "payment-records": {
    title: "支付记录",
    listPath: "/order/payment-record/list",
    detailPath: "/order/payment-record/detail",
    note: "展示支付成功记录，日期留空查询全部，按 ID 倒序。金额由分折算并保留币种。展开记录可查看关联下单及签约摘要。",
    columns: [
      ...identityColumns,
      { title: "支付方式", key: "payType", dataIndex: "payType", width: 120, paymentType: true },
      { title: "下单记录ID", key: "wechatOrderId", dataIndex: "wechatOrderId", width: 120 },
      { title: "实付金额", key: "cashFee", dataIndex: "cashFee", width: 160, amount: true, align: "right" },
      { title: "订单金额", key: "totalFee", dataIndex: "totalFee", width: 160, amount: true, align: "right" },
      { title: "支付次数", key: "paidCount", dataIndex: "paidCount", width: 100, align: "right" },
      { title: "支付结果码", key: "resultCode", dataIndex: "resultCode", width: 140 },
      { title: "订单编号", key: "outTradeNo", dataIndex: "outTradeNo", width: 240 },
      { title: "交易流水号", key: "transactionId", dataIndex: "transactionId", width: 280 },
      { title: "原始交易ID", key: "originalTransactionId", dataIndex: "originalTransactionId", width: 280 },
    ],
    detailFields: [
      ...commonDetails.map((field) => field.key === "paidCount" ? { ...field, label: "支付次数" } : field),
      { key: "userChannel", label: "APK渠道" },
      { key: "payChannel", label: "下单渠道" },
      { key: "bankCode", label: "银行编码" },
      { key: "bankType", label: "付款银行" },
    ],
  },
};

export const formatRecordText = (value) => value === null || value === undefined || value === "" ? "-" : String(value);
const tradeTypeLabels = { hlb: "合利宝", kq: "快钱", airwallex: "空中云汇" };
const paymentTypeLabels = { ...tradeTypeLabels, apple: "苹果", huawei: "华为" };
export const tradeTypePrefix = (value) => typeof value === "string" ? Object.keys(tradeTypeLabels).find((prefix) => value.startsWith(prefix)) : undefined;
export const formatPaymentType = (value) => Object.hasOwn(paymentTypeLabels, value) ? paymentTypeLabels[value] : formatRecordText(value);
export const formatOrderChannel = (value) => {
  const prefix = tradeTypePrefix(value);
  return prefix ? tradeTypeLabels[prefix] : formatRecordText(value);
};
export const formatTradeType = (value) => {
  const prefix = tradeTypePrefix(value);
  return prefix ? tradeTypeLabels[prefix] + value.slice(prefix.length) : formatRecordText(value);
};
export const formatRecordAmount = (value, currency) => {
  if (value === null || value === undefined || value === "" || !Number.isFinite(Number(value))) return "-";
  const amount = (Number(value) / 100).toLocaleString("zh-CN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return currency === "CNY" ? `¥${amount}` : `${amount} ${currency || "币种未知"}`;
};
export const paymentState = (record) => record.isPaid === true ? "支付成功" : record.isPaid === false ? "未支付" : "-";
export const agreementState = (record) => {
  if (record.agreementStatus === "not_loaded") return { label: "展开查看", color: "default", description: "展开记录查看签约关联。" };
  if (record.agreementStatus === "matched" && record.agreement) return { label: "已关联", color: "green", description: "" };
  if (record.agreementStatus === "not_applicable") return { label: "无需关联", color: "default", description: "该支付方式无需关联签约记录。" };
  return { label: "未找到", color: "orange", description: "未找到与原始交易ID对应的签约记录。" };
};
export const formatRecordField = (record, field) => {
  const value = record?.[field.source || field.key];
  if (field.providerTradeType) return formatOrderChannel(value);
  if (field.paymentType) return formatPaymentType(value);
  if (field.tradeType) return formatTradeType(value);
  if (field.amount) return formatRecordAmount(value, record?.currency);
  if (field.boolean) return value === true ? "是" : value === false ? "否" : "-";
  if (field.provider) return ({ airwallex: "空中云汇", hlb: "合利宝", kq: "快钱" }[value] || formatRecordText(value));
  return formatRecordText(value);
};
